import { date } from '../../utils';
export const DEFAULT_MIN_DATE = date.parseDate('1920-01-01');
